import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "select-kit/components/combo-box";
import { pluginApiIdentifiers, selectKitOptions } from "./select-kit";
const FontSelector = dt7948.c(class FontSelector extends ComboBoxComponent {
  modifyComponentForRow() {
    return "font-selector/font-selector-row";
  }
}, [selectKitOptions({
  selectedNameComponent: "selected-font"
}), pluginApiIdentifiers(["font-selector"]), classNames("font-selector")]);
export default FontSelector;